import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
import { useDragDropComponentsContext } from 'crm-cards-sdk/internal/DragDropComponentsContext';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { useLocationService } from '../../internal/LocationServiceContext';
import { getCrmContainerContentId } from '../../utils/crmContainerContentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Will render the container with drag and drop functionality if the layout is reorderable and the dragDropComponents are provided.
 * Otherwise, it will render the container without drag and drop functionality.
 */
export function MaybeDragAndDropList({
  layout,
  containerId,
  renderContainerContents,
  contents
}) {
  var _layout$reorderable;
  const dragDropComponents = useDragDropComponentsContext();
  const reorderable = (_layout$reorderable = layout === null || layout === void 0 ? void 0 : layout.reorderable) !== null && _layout$reorderable !== void 0 ? _layout$reorderable : false;
  const {
    updateCardOrder
  } = useLocationService();
  const {
    location
  } = useCardLocationContext();
  const handleUpdateCardOrder = useCallback(orderedCardIds => {
    if (updateCardOrder) {
      updateCardOrder(orderedCardIds);
    } else {
      Raven.captureException(new Error('MaybeDragAndDropList: card order updated but no updateCardOrder present in LocationService, card order will not be saved'));
    }
  }, [updateCardOrder]);
  if (reorderable && dragDropComponents && dragDropComponents.DragList) {
    return /*#__PURE__*/_jsx(dragDropComponents.DragList, {
      onOrderChange: handleUpdateCardOrder,
      dragGroupId: containerId || location,
      orderedItems: contents.map(containerOrCard => ({
        ariaLabel: `${containerOrCard.type === 'CARD' ? containerOrCard.definition.cardTitle : containerOrCard.label}`,
        id: getCrmContainerContentId(containerOrCard),
        children: renderContainerContents(containerOrCard)
      }))
    });
  }
  if (reorderable && !dragDropComponents) {
    Raven.captureMessage('MaybeDragAndDropList: no dragDropComponents passed in for location with reorderable=true, drag and drop functionality cannot be used');
  }
  return contents.map(renderContainerContents);
}